import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { AuthProvider, useAuth } from "@/lib/auth";
import { HomePage } from "@/pages/Home";
import { LoginPage } from "@/pages/Login";
import { SignupPage } from "@/pages/Signup";
import { DiscoverPage } from "@/pages/Discover";
import { CreatorPage } from "@/pages/CreatorPage";
import { RequestBuilderPage } from "@/pages/RequestBuilder";
import { ClientDashboardPage } from "@/pages/Dashboard";
import { StudioPage } from "@/pages/Studio";
import { ServiceEditorPage } from "@/pages/ServiceEditor";
import { JobDetailPage } from "@/pages/JobDetail";
import { SettingsPage } from "@/pages/Settings";
import { PrivacyPage } from "@/pages/Privacy";
import { TermsPage } from "@/pages/Terms";
import { AIPolicyPage } from "@/pages/AIPolicy";
import "./index.css";

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/discover" element={<DiscoverPage />} />

            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/ai-policy" element={<AIPolicyPage />} />

            <Route path="/dashboard" element={<Protected><ClientDashboardPage /></Protected>} />
            <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />

            <Route path="/studio" element={<Protected><StudioPage /></Protected>} />
            <Route path="/studio/services/new" element={<Protected><ServiceEditorPage /></Protected>} />
            <Route path="/studio/services/:id" element={<Protected><ServiceEditorPage /></Protected>} />

            <Route path="/jobs/:id" element={<Protected><JobDetailPage /></Protected>} />

            <Route path=":handle" element={<CreatorPage />} />
            <Route path=":handle/:slug" element={<RequestBuilderPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
